var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("article", { staticClass: "box p-3" }, [
      _c("div", { staticClass: "columns full-quote-page-height" }, [
        _c(
          "div",
          { staticClass: "column is-4 br-gray-2" },
          [
            _vm.detailInfo.editDefaultOption
              ? _c("parts-list", {
                  attrs: {
                    "default-options": _vm.detailInfo.editDefaultOption,
                  },
                  on: { "request-type": _vm.requestType },
                  model: {
                    value: _vm.partsList,
                    callback: function ($$v) {
                      _vm.partsList = $$v
                    },
                    expression: "partsList",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-4 br-gray-2" },
          [
            _vm.states != null
              ? _c("parts-suppliers", {
                  attrs: {
                    states: _vm.states,
                    "vehicle-make-id": _vm.vehicleMakeId,
                    "preferred-suppliers-prop": _vm.preferredSuppliers,
                    "is-normal": _vm.isNormal,
                    "specialist-supplier": _vm.specialistSupplier,
                    "max-suppliers-count": _vm.maxSuppliersCount,
                  },
                  on: {
                    "get-selected-suppliers": _vm.getSelectedSuppliers,
                    "supplier-list": _vm.supplierList,
                    "get-supplier-list": _vm.getSupplierList,
                  },
                  model: {
                    value: _vm.suppliers,
                    callback: function ($$v) {
                      _vm.suppliers = $$v
                    },
                    expression: "suppliers",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-4" },
          [
            _vm.marginSettings !== null && _vm.timeSlots.length > 0
              ? _c("price-parts-details", {
                  attrs: {
                    "time-slots": _vm.timeSlots,
                    "margin-settings": _vm.marginSettings,
                    "image-ids": _vm.imageIds,
                    "quote-id": _vm.value.quoteId,
                    "is-normal": _vm.isNormal,
                  },
                  on: {
                    "create-price-parts-request": _vm.createPricePartsRequest,
                    onCancel: _vm.onCancel,
                  },
                  model: {
                    value: _vm.detailInfo,
                    callback: function ($$v) {
                      _vm.detailInfo = $$v
                    },
                    expression: "detailInfo",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }